import {AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewChildren} from '@angular/core';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {RSLoadingModalService} from '../../../libs/rsloading/rsloading.service';
import {
  PracticeChangeFormFertiliser,
  PracticeChangeFormSoil,
  PracticeChangeFormWater
} from '../../services/practice-change.types';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {RSValidatorFormDirective} from '../../../libs/rsvalidator/rsvalidator.directive';
import {MatTabGroup} from '@angular/material/tabs';

@Component({
  selector: 'app-practice-change-soils',
  templateUrl: './practice-change-soils.component.html',
  styleUrls: ['./practice-change-soils.component.scss']
})
export class PracticeChangeSoilsComponent extends RSDialogComponentModel implements OnInit, AfterViewInit {
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  @ViewChild('tabGroup', {static: true, read: MatTabGroup}) tabGroup: MatTabGroup;
  @ViewChildren('form', { read: RSValidatorFormDirective }) inputForms;

  public get input(): PracticeChangeFormSoil {
    return (this.dialogValues?.inputs || new PracticeChangeFormSoil());
  }

  constructor() {
    super();
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  next() {
    const index = this.tabGroup.selectedIndex;
    const total = this.tabGroup._allTabs.length - 1;
    const invalid = this.inputForms.toArray().findIndex(i => !i.isValid(true));
    if (invalid === -1 || invalid > index) {
      if (this.tabGroup.selectedIndex === total) {
        this.save();
      } else {
        this.tabGroup.selectedIndex = this.tabGroup.selectedIndex + 1;
      }
    } else {
      this.tabGroup.selectedIndex = invalid;
    }
  }

  save() {
    const invalid = this.inputForms.toArray().findIndex(i => !i.isValid(true));
    if (invalid !== -1) {
      this.tabGroup.selectedIndex = invalid;
    } else {
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

}
